import { Clock } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { QuickTimelogPopover } from './quick-timelog-popover'

export interface QuickTimelogButtonProps {
  /** 任务 ID */
  issueId: string
  /** 任务名称 */
  issueName: string
  /** 项目 ID */
  projectId?: string
  /** 成功回调 */
  onSuccess?: () => void
  /** 按钮大小 */
  size?: 'sm' | 'default' | 'icon'
  /** 自定义类名 */
  className?: string
}

/**
 * 快捷工时记录按钮
 * 点击后弹出工时记录 Popover
 */
export function QuickTimelogButton({
  issueId,
  issueName,
  projectId,
  onSuccess,
  size = 'icon',
  className,
}: QuickTimelogButtonProps) {
  return (
    <QuickTimelogPopover
      issueId={issueId}
      issueName={issueName}
      projectId={projectId}
      onSuccess={onSuccess}
      trigger={
        <Button
          variant="ghost"
          size={size}
          className={cn(
            'h-7 w-7 text-muted-foreground hover:text-foreground',
            className
          )}
          title="快速记录工时"
          onClick={(e) => e.stopPropagation()}
        >
          <Clock className="h-4 w-4" />
        </Button>
      }
    />
  )
}
